"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Expandable from "../_private/Expandable/index.js";
import View from "../View/index.js";
import AccordionContext from "./Accordion.context.js";
const AccordionContent = (props) => {
    const { children } = props;
    const { active, triggerId, contentId, gap } = React.useContext(AccordionContext);
    return (_jsx(Expandable, { active: active, attributes: { "aria-labelledby": triggerId, id: contentId }, children: gap ? _jsx(View, { paddingTop: gap, children: children }) : children }));
};
AccordionContent.displayName = "Accordion.Content";
export default AccordionContent;
